export function useListContextValues_unstable(state) {
    const { selection, navigationMode, listItemRole, validateListItem } = state;
    const listContext = {
        selection,
        listItemRole,
        navigationMode,
        validateListItem
    };
    return {
        listContext
    };
}
